import * as React from "react"

/**
 * Wraps the text children of a control so that long text is cut off with an ellipsis next to its icons.
 * Text directly in a flex row cannot be truncated, so each text child gets an element of its own.
 */
function truncateLabel(children: React.ReactNode): React.ReactNode {
  return React.Children.map(children, (child) =>
    typeof child === "string" || typeof child === "number" ? (
      <span data-part="label" className="min-w-0 truncate">
        {child}
      </span>
    ) : (
      child
    )
  )
}

export { truncateLabel }
